module.exports = __webpack_public_path__ + "img/logo.00231e99.png";